import Baggage from './components/Baggage.css';
import BaggageIcon from './components/BaggageIcon/BaggageIcon.css';

export default {
	Baggage,
	BaggageIcon
};
